import { NewTrip } from 'entities/Trip';
import { Document } from 'entities/Document/interfaces';
import {
  CLEAN_ERROR,
  CLEAN_TRIP,
  DELETE_TRIP_ERROR,
  DELETE_TRIP_REQUEST,
  DELETE_TRIP_SUCCESS,
  FORCE_SAVED,
  GET_NEW_TRIP_ERROR,
  GET_NEW_TRIP_REQUEST,
  GET_NEW_TRIP_SUCCESS,
  GET_TRIP_ERROR,
  GET_TRIP_REQUEST,
  GET_TRIP_SUCCESS,
  SAVED_TRIP,
  SET_VISITOR_NAME,
  UPDATE_TRIP_ERROR,
  UPDATE_TRIP_REQUEST,
  UPDATE_TRIP_STATUS,
  UPDATE_TRIP_SUCCESS,
  UPDATE_NEW_TRIP_SUCCESS,
  SET_SMS_FLAG,
  UPDATE_TRIP_STATUS_SUCCESS,
  DELETE_ORDER_FROM_TRIP_REQUEST,
  DELETE_ORDER_FROM_TRIP_SUCCESS,
  DELETE_ORDER_FROM_TRIP_ERROR,
  HAS_WARNING,
  CLEAN_WARNING,
  PUT_NEXT_STEP_REQUEST,
  PUT_NEXT_STEP_SUCCESS,
  PUT_NEXT_STEP_ERROR,
} from './constants';

export const getNewTripRequest = (tripIntent: number) => ({
  type: GET_NEW_TRIP_REQUEST,
  payload: tripIntent,
});

export const setVisitorName = (visitor: any[]) => ({
  type: SET_VISITOR_NAME,
  payload: visitor,
});

export const getNewTripSuccess = (trip: NewTrip, docs: Document[]) => ({
  type: GET_NEW_TRIP_SUCCESS,
  payload: trip,
  docs,
});

export const getNewTripError = (error: Error | null) => ({
  type: GET_NEW_TRIP_ERROR,
  payload: error,
});

export const saveTrip = (isSave: boolean = false) => ({
  type: SAVED_TRIP,
  payload: isSave,
});

export const forceSaved = (save: string | null) => ({
  type: FORCE_SAVED,
  payload: save,
});

export const updateNewTripSuccess = (trip: any) => ({
  type: UPDATE_NEW_TRIP_SUCCESS,
  payload: trip,
});

export const updateTripRequest = (
  trip: any,
  isSave: boolean = false,
  userStatusId?: number,
  statusId?: number | number[],
) => ({
  type: UPDATE_TRIP_REQUEST,
  payload: { trip, isSave },
  userStatusId,
  statusId,
});

export const updateTripSuccess = () => ({
  type: UPDATE_TRIP_SUCCESS,
});

export const updateTripStatus = (trip: any) => ({
  type: UPDATE_TRIP_STATUS,
  payload: { trip },
});
export const updateTripStatusSuccess = () => ({
  type: UPDATE_TRIP_STATUS_SUCCESS,
});

export const updateTripError = (error: any | null) => ({
  type: UPDATE_TRIP_ERROR,
  payload: error,
});

export const deleteTripRequest = (tripId: number, tripIntention: number) => ({
  type: DELETE_TRIP_REQUEST,
  payload: { tripId, tripIntention },
});

export const deleteTripSuccess = () => ({
  type: DELETE_TRIP_SUCCESS,
});

export const deleteTripError = (error: Error | null) => ({
  type: DELETE_TRIP_ERROR,
  payload: error,
});

export const getTripRequest = (id: string, params: any = {}) => ({
  type: GET_TRIP_REQUEST,
  payload: { id, params },
});

export const getTripSuccess = (orderValue: any) => ({
  type: GET_TRIP_SUCCESS,
  payload: orderValue,
});

export const getTripError = (error: Error | null) => ({
  type: GET_TRIP_ERROR,
  payload: error,
});

export const setSMSFlag = (flag: any) => ({
  type: SET_SMS_FLAG,
  payload: flag,
});

export const cleanTrip = () => ({
  type: CLEAN_TRIP,
});

export const cleanError = () => ({
  type: CLEAN_ERROR,
});

export const deleteOrderFromTripRequest = (order: any, values: any, removeIndex: number) => ({
  type: DELETE_ORDER_FROM_TRIP_REQUEST,
  payload: order,
  values,
  removeIndex,
});

export const deleteOrderFromTripSuccess = (trip: any) => ({
  type: DELETE_ORDER_FROM_TRIP_SUCCESS,
  payload: trip,
});

export const deleteOrderFromTripError = (error: Error | null) => ({
  type: DELETE_ORDER_FROM_TRIP_ERROR,
  payload: error,
});

export const hasWarning = (errorMessages: any, warning: boolean, trip: any, docs: any) => ({
  type: HAS_WARNING,
  payload: errorMessages,
  warning,
  trip,
  docs,
});

export const cleanWarning = () => ({
  type: CLEAN_WARNING,
});

export const putNextStepRequest = (body: any) => ({
  type: PUT_NEXT_STEP_REQUEST,
  payload: body,
});
export const putNextStepSuccess = () => ({
  type: PUT_NEXT_STEP_SUCCESS,
});
export const putNextStepError = (error: any) => ({
  type: PUT_NEXT_STEP_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof putNextStepRequest>
  | ReturnType<typeof putNextStepSuccess>
  | ReturnType<typeof putNextStepError>
  | ReturnType<typeof hasWarning>
  | ReturnType<typeof cleanWarning>
  | ReturnType<typeof setVisitorName>
  | ReturnType<typeof deleteOrderFromTripRequest>
  | ReturnType<typeof deleteOrderFromTripSuccess>
  | ReturnType<typeof deleteOrderFromTripError>
  | ReturnType<typeof getNewTripRequest>
  | ReturnType<typeof getNewTripSuccess>
  | ReturnType<typeof getNewTripError>
  | ReturnType<typeof updateTripRequest>
  | ReturnType<typeof updateTripSuccess>
  | ReturnType<typeof updateTripStatus>
  | ReturnType<typeof updateTripError>
  | ReturnType<typeof deleteTripRequest>
  | ReturnType<typeof deleteTripSuccess>
  | ReturnType<typeof deleteTripError>
  | ReturnType<typeof getTripRequest>
  | ReturnType<typeof getTripSuccess>
  | ReturnType<typeof getTripError>
  | ReturnType<typeof cleanTrip>
  | ReturnType<typeof saveTrip>
  | ReturnType<typeof forceSaved>
  | ReturnType<typeof updateNewTripSuccess>
  | ReturnType<typeof setSMSFlag>
  | ReturnType<typeof updateTripStatusSuccess>
  | ReturnType<typeof cleanError>;
